// Site-wide static content
export const stats = [
  { letter: "A", label: "PRACTICE", value: 13, suffix: " yrs", description: "Continuous senior practice across product, creative, AI and content." },
  { letter: "B", label: "ENGAGEMENTS", value: 40, suffix: "+", description: "Direct ownership across enterprise, founder-led and cultural mandates." },
  { letter: "C", label: "LAYERS", value: 2, description: "Macro direction and micro execution, held by the same operator." },
  { letter: "D", label: "OPERATING MODE", value: 1, description: "Embedded as a function head, not retained as a vendor." },
];

// Integrated capability stack, four disciplines, one operator.
export const expertise = [
  { letter: "A", title: "Creative Direction", description: "Concept, visual systems and narrative, held consistent across product, film and content surfaces." },
  { letter: "B", title: "Product & Experience", description: "Interface architecture, workflow and decision design, built for leadership users in complex environments." },
  { letter: "C", title: "AI & Automation Systems", description: "Generative pipelines and structured input-to-output systems that scale production without losing intent." },
  { letter: "D", title: "Copy & Content Design", description: "Messaging architecture, UX writing and long-form voice, one register across product and communication." },
];

export const publications = [
  { type: "KEYNOTE", title: "Holding Two Layers At Once", venue: "Design Leadership Forum", year: "'24" },
  { type: "WORKSHOP", title: "Generative Systems as an Operating Question", venue: "Product Systems Cohort", year: "'24" },
  { type: "ROUNDTABLE", title: "When Brand Becomes Infrastructure", venue: "Brand & Business Roundtable", year: "'23" },
  { type: "ESSAY", title: "Notes on Editing as Leadership", venue: "Independent Design Journal", year: "'23" },
  { type: "MASTERCLASS", title: "Direction Without Drift", venue: "Design Education Collective", year: "'22" },
];

// Depth = posture, not score. Lead = sets the standard; Operate = ships at it;
// Direct = governs others to it. Foregrounds AI & Automation as the seam.
export const skillDomains = [
  {
    category: "AI TRANSFORMATION",
    note: "Designing the systems where content, decisions and execution compound through AI. Built to scale across teams, workflows and products.",
    skills: [
      { name: "Generative Pipeline Architecture", depth: "Lead", outcome: "Scales content production" },
      { name: "Agentic Workflow Orchestration", depth: "Lead", outcome: "Reduces manual execution" },
      { name: "Structured Input → Output Systems", depth: "Lead", outcome: "Improves consistency" },
      { name: "Prompt & Schema Design", depth: "Lead", outcome: "Increases AI reliability" },
      { name: "Model Selection & Evaluation", depth: "Operate", outcome: "Optimizes quality & cost" },
      { name: "Production Quality Controls", depth: "Direct", outcome: "Maintains enterprise standards" },
    ],
  },
  {
    category: "PRODUCT & EXPERIENCE",
    note: "Creating products that align business goals, user needs and operational realities.",
    skills: [
      { name: "Product Strategy", depth: "Lead", outcome: "Clarifies direction" },
      { name: "Product Discovery", depth: "Lead", outcome: "Reduces delivery risk" },
      { name: "Information Architecture", depth: "Lead", outcome: "Improves findability" },
      { name: "UX & Interaction Design", depth: "Lead", outcome: "Improves usability" },
      { name: "Design Systems", depth: "Lead", outcome: "Increases velocity" },
      { name: "Service Design", depth: "Operate", outcome: "Connects experiences" },
    ],
  },
  {
    category: "CREATIVE & BRAND",
    note: "Building coherent narratives, systems and experiences that create recognition and trust at scale.",
    skills: [
      { name: "Creative Direction", depth: "Lead", outcome: "Drives coherence" },
      { name: "Positioning & Messaging", depth: "Lead", outcome: "Defines differentiation" },
      { name: "Brand Architecture", depth: "Lead", outcome: "Creates clarity" },
      { name: "Narrative Systems", depth: "Lead", outcome: "Strengthens consistency" },
      { name: "Campaign Development", depth: "Operate", outcome: "Drives engagement" },
      { name: "Content Strategy", depth: "Lead", outcome: "Improves relevance" },
    ],
  },
  {
    category: "ORGANIZATIONAL DESIGN",
    note: "Designing the structures, workflows and operating models that improve execution and decision quality.",
    skills: [
      { name: "Workflow Architecture", depth: "Lead", outcome: "Removes friction" },
      { name: "Knowledge Systems", depth: "Lead", outcome: "Captures intelligence" },
      { name: "Design Operations", depth: "Direct", outcome: "Improves scale" },
      { name: "Creative Operations", depth: "Direct", outcome: "Increases throughput" },
      { name: "Organizational Design", depth: "Lead", outcome: "Enables alignment" },
      { name: "Transformation Programs", depth: "Direct", outcome: "Accelerates change" },
    ],
  },
];
